const EaseInOutIcon = /*#__PURE__*/ [
  ["path", { d: "M21 4C11.0535 4 12.9465 20 3 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { EaseInOutIcon as default };
//# sourceMappingURL=EaseInOutIcon.js.map
